import { Component, Inject } from "@angular/core";
import * as Immutable from "immutable";
import { ConfDocumentValue, DocumentsPanel } from "../../../shared/models";
import { ConfiguratorStore, ConfPageSessionService } from "../../providers";
import { PanelComponent } from "../../shared/panelComponent";
import { VisualObjectVisibilityService } from "../../shared";
import { VisualObjectHelper } from "../../parameters/shared";

@Component({
  selector: 'documents-panel',
  templateUrl: './documentsPanelComponent.html'
})
export class DocumentsPanelComponent extends PanelComponent<DocumentsPanel> {

  public documentValues: Array<ConfDocumentValue>;

  constructor(
    public confStore: ConfiguratorStore,
    public confPageSessionService: ConfPageSessionService,
    @Inject(VisualObjectHelper) public visualObjectHelper: VisualObjectHelper,
    public visualObjectVisibilityService: VisualObjectVisibilityService
  ) {
    super(confStore, confPageSessionService, visualObjectHelper);
  }

  public listenChanges(): void {

    this.confStore.onConfDocumentValuesChange(this.configurationId, this.confSessionId, this.panel.longId,
      (documentValues: Immutable.List<ConfDocumentValue>): void => {

        this.documentValues = [];

        const confUIItem = this.visualObjectVisibilityService.findConfUIItem(this.configuration, this.panel.longId);
        if (confUIItem) {
          confUIItem.items.forEach(item => {
            const value = documentValues.find(x => x.longId === item.id);
            if(value)
              this.documentValues.push(value);
          });
        }
      }).unsubscribeOn(this.unsubscribeSubject);
  }
}